/**
 * AtlasWalletModule — the always-on currency HUD.
 *
 * Renders the local player's dual-currency balances (Sovereigns / Influence)
 * in a top-center pill. Purely event-driven: the network module mirrors the
 * authoritative `wallet` row into shared state and fires `atlas:wallet-updated`,
 * which is the only thing that moves these numbers. The client never computes a
 * balance itself — it only displays what the server's double-entry ledger says.
 */

import type { App, IModule } from 'enginex';
import { atlas } from '../state.js';
import { bus } from '../bus.js';
import { CURRENCY } from '../config.js';

export class AtlasWalletModule implements IModule {
  readonly name = 'AtlasWallet';

  private el!: HTMLElement;

  init(_app: App): void {
    this.el = document.getElementById('wallet') as HTMLElement;

    // The wallet row resolves shortly after the passport is ready; reveal the
    // HUD then so it never flashes "0 SOV" on the login kiosk.
    bus.on('atlas:account-ready', () => {
      this.el.classList.add('show');
      this.render();
    });
    bus.on('atlas:wallet-updated', () => this.render());

    this.render();
  }

  private render(): void {
    this.el.innerHTML =
      `<span class="sov">\u24d2 ${atlas.walletSov.toString()} credits</span>`; // credits unification — one currency, one line
  }
}
